export default "__VITE_ASSET__6f94cf28__"